import SyncIcon from '@mui/icons-material/Sync';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

export const spEtailizeWebshopDetailsConfig = {
    details: {
        title: 'details',
        icon: <InfoOutlinedIcon/>,
    },
    sync: {
        title: 'sync',
        icon: <SyncIcon/>,
    },
    orders: {
        title: 'orders',
        icon: <FormatListBulletedIcon/>,
    },
};